import { render, staticRenderFns } from "./BillingTab.vue?vue&type=template&id=5bd37f62&scoped=true"
import script from "./BillingTab.vue?vue&type=script&lang=js"
export * from "./BillingTab.vue?vue&type=script&lang=js"
import style0 from "./BillingTab.vue?vue&type=style&index=0&id=5bd37f62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd37f62",
  null
  
)

export default component.exports